import React, { useState, useEffect } from 'react';
import { Row, Col, Descriptions, Tabs, Card } from "antd";

import { TabDetalheItens, TabDetalheRelacaoNota, TabDetalheHistorico } from './tabPages';
import moment from 'moment';
import { FormatFone, MaskFormat } from '../../ValueObjects/index';
import api from '../../services/api';
import TabDetalheFormaPagamento from './tabDetalheFormaPagamento';
import TabDetalheEquipamento from './tabDetalheEquipamento';
import TabDetalhesOS from './tabDetalhesOS';

export default function DetalheOrdemServico({ dadosModal }) {

    const [abaSelecionada, setAbaSelecionada] = useState("1");
    const [pedido, setPedido] = useState({});
    const [dadosNota, setDadosNota] = useState([]);
    const [abaRelacionamento, setAbaRelacionamento] = useState(false);
    const [listaStatusNota, setListaStatusNota] = useState([]);

    useEffect(() => {
        if (!!dadosModal) {
            if (!!dadosModal?.ped_id) {
                setPedido(dadosModal)
            }
            retornaStatusNF();
            buscarRelacionamento();
        }
    }, [dadosModal]);


    function retornaStatusNF() {
        api.get('Enum/Listar?nome=StatusNFe').then(
            (res) => {
                if (res.status === 200) {
                    setListaStatusNota(res.data);
                }
            }
        ).catch(
            (erro) => {
                console.log(erro);
            }
        )
    };

    async function buscarRelacionamento() {
        let retorno = await api.get(`Pedido/ListarRelacionamento?IdPed=${dadosModal.ped_id}`);
        if (retorno.status === 200) {
            if (retorno.data.length > 0) {
                setDadosNota(retorno.data);
                setAbaRelacionamento(true);
            }
        }
    }

    function displayValue(value, fallback = 'NÃO INFORMADO') {
        return value ? value : fallback;
    }

    return (
        <div>
            <Card title="Identificação do Destinatário"
                size="small"
                className="card-top"
                styles={{ header: { backgroundColor: '#f1f1f1' } }}
            >
                <Descriptions size='small' labelStyle={{ fontWeight: 'bold' }}>
                    <Descriptions.Item label="Nome">{displayValue(pedido.pes_nome)}</Descriptions.Item>
                    <Descriptions.Item label="CPF/CNPJ">
                        {(!!pedido.pef_cpf ? MaskFormat(pedido.pef_cpf, '', true) : (!!pedido.pej_cnpj ? MaskFormat(pedido.pej_cnpj, '', true) : 'NÃO INFORMADO'))}
                    </Descriptions.Item>
                    <Descriptions.Item label="IE">{displayValue(pedido.ped_iedest)}</Descriptions.Item>
                    <Descriptions.Item label="E-mail">{displayValue(pedido.pem_email)}</Descriptions.Item>
                    <Descriptions.Item label="Telefone">{!!pedido.pes_telefone ? FormatFone(pedido.pes_telefone) : 'NÃO INFORMADO'}</Descriptions.Item>
                </Descriptions>
                <Descriptions size="small" labelStyle={{ fontWeight: 'bold' }}>
                    <Descriptions.Item label="Endereço">
                            {pedido.pes_endereco || 'NÃO INFORMADO'},
                            {pedido.pes_nroestabelecimento && `, Nº ${pedido.pes_nroestabelecimento}`}
                            {pedido.pes_bairro && `, ${pedido.pes_bairro}`}
                            {pedido.pes_cidade && ` - ${pedido.pes_cidade}`}
                            {pedido.pes_uf && `/${pedido.pes_uf}`}
                            {pedido.pes_cep && ` - CEP ${MaskFormat(pedido.pes_cep, '00000-000')}`}
                    </Descriptions.Item>
                </Descriptions>
            </Card>
            <Card title="Dados da Ordem de Serviço Assistência Técnica"
                size='small'
                className='card-bottom'
                styles={{ header: { backgroundColor: '#f1f1f1', borderTopLeftRadius: 0, borderTopRightRadius: 0 } }}
            >
                <Descriptions size="small" labelStyle={{ fontWeight: 'bold' }}>
                    <Descriptions.Item label="Número">{pedido.ped_numero}</Descriptions.Item>
                    <Descriptions.Item label="Data de Emissão">{!!pedido.ped_datainclusao ? moment(pedido.ped_datainclusao).format('DD/MM/YYYY') : null}</Descriptions.Item>
                    <Descriptions.Item label="Técnico Responsável">{displayValue(pedido.fun_nome)}</Descriptions.Item>
                </Descriptions>
            </Card>
            <div className="m-t-8">
                <Tabs type="card" centered activeKey={abaSelecionada} onChange={(tab) => setAbaSelecionada(tab)}>
                    <Tabs.TabPane tab="Equipamento" key="1">
                        <TabDetalheEquipamento equipamento={pedido} />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Detalhes da OS" key="2">
                        <TabDetalhesOS ordemservico={pedido} />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Itens" key="3">
                        <TabDetalheItens itensNF={pedido.itensNf} />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Formas de Pagamento" key="4">
                        <TabDetalheFormaPagamento formaPagamento={pedido.formaPgto} />
                    </Tabs.TabPane>
                    {abaRelacionamento && <Tabs.TabPane tab="Notas Fiscais" key="5">
                        <TabDetalheRelacaoNota dadosNota={dadosNota} listaStatusNota={listaStatusNota} />
                    </Tabs.TabPane>}
                    <Tabs.TabPane tab="Histórico" key="6">
                        <TabDetalheHistorico historico={pedido.historico} />
                    </Tabs.TabPane>
                </Tabs>
            </div>
        </div >
    );
}